export function Input({ ...props }) {
  return (
    <textarea
      className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
      rows={1}
      {...props}
    />
  );
}
